// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1tp5-","choiceBoxes":"toolbarselects_choiceBoxes__vLlVK","simpleField":"toolbarselects_simpleField__1Zs93"};